import { useCallback, useRef } from 'react';
import useWebSocket, { ReadyState } from 'react-use-websocket';
import Cookies from 'js-cookie';

const useCustomWebSocket = () => {
  const token = Cookies.get('accessToken');
  const socketUrl = `${import.meta.env.VITE_WEBSOCKET_URL}?token=${token}`;
  // const socketUrl = `ws://localhost:3330?token=${token}`;
  const pingIntervalRef = useRef<NodeJS.Timeout>();

  const { sendMessage, lastMessage, readyState } = useWebSocket(socketUrl, {
    onOpen: () => {
      console.log('WebSocket connection established.');
      // Start sending heartbeat when connection opens
      pingIntervalRef.current = setInterval(() => {
        sendMessage(JSON.stringify({ action: 'heartbeat' }));
        console.log('heartbeat');
      }, 25000); // Send heartbeat every 25 seconds
    },
    onClose: () => {
      console.log('WebSocket connection closed.');
      // Clear heartbeat interval on connection close
      if (pingIntervalRef.current) {
        clearInterval(pingIntervalRef.current);
      }
    },
    onError: (error) => console.error('WebSocket error:', error),
    onMessage: (message) => console.log('message received:', message.data),
    shouldReconnect: (closeEvent) => true,
  });

  const isOpen = readyState === ReadyState.OPEN;

  // Function to send a message if the WebSocket is open
  const sendDirectMessage = useCallback(
    (message: string, convoID: number, socialId: number) => {
      if (isOpen) {
        const payload = JSON.stringify({
          message,
          convoID,
          action: 'send_message',
          socialId,
        });
        console.log('Sending:', payload);
        sendMessage(payload);
      }
    },
    [isOpen, sendMessage]
  );

  const requestConversation = useCallback(
    (convoID: number) => {
      if (isOpen) {
        const payload = JSON.stringify({
          action: 'request_conversation',
          convoID,
        });
        sendMessage(payload);
      }
    },
    [isOpen, sendMessage]
  );

  const sendWebSocketMessage = useCallback(
    (action: string, data: any) => {
      if (isOpen) {
        const payload = JSON.stringify({
          action,
          ...data,
        });
        console.log('Sending:', payload);
        sendMessage(payload);
      }
    },
    [isOpen, sendMessage]
  );

  return {
    sendWebSocketMessage,
    sendDirectMessage,
    requestConversation,
    lastMessage,
    readyState,
  };
};

export default useCustomWebSocket;
